<head>
  <title></title>
  <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css"
    integrity="sha512-iecdLmaskl7CVkqkXNQ/ZH/XLlvWZOJyj7Yy7tcenmpD1ypASozpmT/E0iPtmFIB46ZmdtAc9eNBvH0H/ZpiBw=="
    crossorigin="anonymous" referrerpolicy="no-referrer" />
</head>

<div class="d-flex justify-content-between">
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <app-breadcrumb id="MainActivity" *ngIf="qmsService.refereshBreadCrumb"></app-breadcrumb>
  <div class="d-flex gap-4 align-items-center">
    <div class="">
      <span class="crDetail-status1 " *ngIf="qi != undefined" [ngStyle]="statusAppearance(qi.status)">
        Status&nbsp;:&nbsp; <span>{{ this.qi.status }}</span>
      </span>
    </div>
    <div class="d-flex gap-2">
      <div class="d-flex align-items-center justify-content-center communication_cta pointer"
        (click)="openExportPopup()" (keydown.enter)="openExportPopup()" matTooltip="Report">
        <img src="../../../assets/img/cr_module/pdf.svg" width="22px" height="20px" alt="" />
      </div>
      <div class="d-flex align-items-center justify-content-center communication_cta  pointer"
        matTooltip="Dependent of">
        <img src="../../../assets/img/qms_img/dependency.svg" width="14px" height="14px" alt=""
          (click)="openDependentsPopup()" (keydown.enter)="openDependentsPopup()" />
      </div>
      <div *ngIf="message.isTopicAdministrator">
        <div class="d-flex align-items-center justify-content-center communication_cta pointer"
          matTooltip="Communication">
          <img src="../../../assets/img/cr_module/communication.svg" width="14px" height="14px" alt=""
            (click)="openTopicPopup()" (keydown.enter)="openTopicPopup()" />
        </div>
      </div>
      <div class="d-flex align-items-center justify-content-center communication_cta communication-icon pointer"
        matTooltip="Tag to Home" (click)="openTag()" (keydown.enter)="openTag()">
        <img src="../../../assets/img/tags.png" width="17px" height="19px" alt="" />
      </div>
    </div>
  </div>
</div>

<div class="page-loading-shade" *ngIf="isProcessing">
  <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
</div>
<div class="d-flex justify-content-between mt-2 mb-2">
  <div class="" style="margin-right: auto;">
    <app-task-stage-statistics *ngIf="qmsService.refereshBreadCrumb"></app-task-stage-statistics>
  </div>
  <div class="" style="margin-right:1%;align-content:center;"
    *ngIf="qmsService.activity.status == 'In Progress' && parallelWorkflowList.length==0  && (qmsService.activity.evaluator == qmsService.loggeduserid)">
    <div matTooltip="Add Workflow" style="
        border: 0.75px solid rgba(222, 235, 254, 0.8980392157);
        border-radius: 100px;
        width: 36px;
        height: 36px;" class="d-flex justify-content-center align-items-center actions_cta pointer"
      (click)="openAddWorkflow()" (keydown.enter)="openAddWorkflow()">
      <a>
        <img title="Switch User" src="..//..//../assets/img/parallel workflow.svg" alt="workflow" width="20"
          height="20">
      </a>
    </div>
  </div>
  <div class="">
    <div class="">
      <app-activity-dynamic-button></app-activity-dynamic-button>
    </div>
  </div>
</div>
<div class="form-template">
  <div class="tab">
    <mat-tab-group mat-stretch-tabs class="activitytab mat-tab-container mat-elevation-z4" animationDuration="0ms"
      (selectedTabChange)="onTabChanged($event);" [(selectedIndex)]="selectedTabIndex" #tabsGroup>
      <mat-tab label="Quality Issue">
        <ng-template mat-tab-label>
          <span>
            <i class='fa fa-check' style="font-size: 18px;" aria-hidden="true"></i>
          </span>&nbsp;<span>{{qmsService.moduleFullName}}</span>
        </ng-template>
        <div *ngIf="dynamicLabel">
          <fieldset class="border p-2 fieldsetStyle">
            <legend class="float-none w-auto p-2">
              <span class="" style="font-size: 14px;color: #cfcfcf;">Details</span>
            </legend>
            <div class="row">
              <div class="col-md-2">
                <div>
                  <!-- Quality Issue ID -->
                  <label for="qi-id">{{dynamicLabel['QI_ID'].fieldName}}</label>
                  <span class="info-icon" *ngIf="dynamicLabel['QI_ID'].fieldNotes"
                    [matTooltip]="dynamicLabel['QI_ID'].fieldNotes">
                    <img [src]="infoIconSrc" alt="note" width="18" height="18">
                  </span>
                </div>
                <input id="qi-id" class="input-filed-continers disabled-input" type="text" [(ngModel)]="qi.qiId"
                  [matTooltip]="qi.qiId" disabled>
              </div>
              <div class="col-md-2">
                <div>
                  <!-- Status -->
                  <label for="status">{{dynamicLabel['STATUS'].fieldName}}</label>
                  <span class="info-icon" *ngIf="dynamicLabel['STATUS'].fieldNotes"
                    [matTooltip]="dynamicLabel['STATUS'].fieldNotes">
                    <img [src]="infoIconSrc" alt="note" width="18" height="18">
                  </span>
                </div>
                <input id="status" class="input-filed-continers disabled-input" type="text" [(ngModel)]="qi.status"
                  disabled>
              </div>
              <div class="col-md-2">
                <div>
                  <!-- Initiated By -->
                  <label for="initiator-user">{{dynamicLabel['INITIATOR_USER'].fieldName}}</label>
                  <span class="info-icon" *ngIf="dynamicLabel['INITIATOR_USER'].fieldNotes"
                    [matTooltip]="dynamicLabel['INITIATOR_USER'].fieldNotes">
                    <img [src]="infoIconSrc" alt="note" width="18" height="18">
                  </span>
                </div>
                <input id="initiator-user" class="input-filed-continers disabled-input" type="text"
                  [(ngModel)]="qi.initiatorUser" disabled>
              </div>
              <div class="col-md-2">
                <div>
                  <!-- Quality Issue Type -->
                  <label for="qi-type" id="qi-type-validation">
                    {{dynamicLabel['QI_TYPE'].fieldName}}
                  </label> <span class="mandatory-symbol">*</span>
                  <span class="qms-risk-icon" for="email" id="type" style="padding: 2px;"
                    [matTooltip]="'Update ' + dynamicLabel['QI_TYPE']?.fieldName"
                    [class.disabled]="isDetailSectionFrozen && !elite_Action_EC_Risk" (click)="openUpdateType()"
                    (keydown.enter)="openUpdateType()" *ngIf="showUpdateType">
                    <svg width="20" height="20" fill="#000000" viewBox="0 0 36 36" version="1.1"
                      preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink">
                      <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                      <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                      <g id="SVGRepo_iconCarrier">
                        <path
                          d="M19.5,28.1h-2.9c-0.5,0-0.9-0.3-1-0.8l-0.5-1.8c-0.2-0.1-0.2-0.1-0.4-0.2l-1.6,0.9c-0.4,0.2-0.9,0.2-1.2-0.2l-2.1-2.1 c-0.3-0.3-0.4-0.8-0.2-1.2l0.9-1.6c-0.1-0.2-0.1-0.2-0.2-0.4l-1.8-0.5c-0.4-0.1-0.8-0.5-0.8-1v-2.9c0-0.5,0.3-0.9,0.8-1l1.8-0.5 c0.1-0.2,0.1-0.2,0.2-0.4l-0.9-1.6c-0.2-0.4-0.2-0.9,0.2-1.2l2.1-2.1c0.3-0.3,0.8-0.4,1.2-0.2l1.6,0.9c0.2-0.1,0.2-0.1,0.4-0.2 l0.5-1.8c0.1-0.4,0.5-0.8,1-0.8h2.9c0.5,0,0.9,0.3,1,0.8l0.5,1.8c0.2,0.1,0.2,0.1,0.4,0.2l1.6-0.9c0.4-0.2,0.9-0.2,1.2,0.2 l2.1,2.1c0.3,0.3,0.4,0.8,0.2,1.2l-0.9,1.6c0.1,0.2,0.1,0.2,0.2,0.4l1.8,0.5c0.4,0.1,0.8,0.5,0.8,1v2.9c0,0.5-0.3,0.9-0.8,1 l-1.8,0.5c-0.1,0.2-0.1,0.2-0.2,0.4l0.9,1.6c0.2,0.4,0.2,0.9-0.2,1.2l-2.1,2.1c-0.3,0.3-0.8,0.4-1.2,0.2l-1.6-0.9 c-0.2,0.1-0.2,0.1-0.4,0.2l-0.5,1.8C20.3,27.8,19.9,28.1,19.5,28.1z M17.3,26.1h1.4l0.5-2.1l0.5-0.2c0.4-0.1,0.7-0.3,1.1-0.4 l0.5-0.3l1.9,1.1l1-1l-1.1-1.9l0.3-0.5c0.2-0.3,0.3-0.7,0.4-1.1l0.2-0.5l2.1-0.5v-1.4L24,16.8l-0.2-0.5c-0.1-0.4-0.3-0.7-0.4-1.1 l-0.3-0.5l1.1-1.9l-1-1l-1.9,1.1l-0.5-0.3c-0.3-0.2-0.7-0.3-1.1-0.4L19.2,12l-0.5-2.1h-1.4L16.8,12l-0.5,0.2 c-0.4,0.1-0.7,0.3-1.1,0.4l-0.5,0.3l-1.9-1.1l-1,1l1.1,1.9l-0.3,0.5c-0.2,0.3-0.3,0.7-0.4,1.1L12,16.8l-2.1,0.5v1.4l2.1,0.5 l0.2,0.5c0.1,0.4,0.3,0.7,0.4,1.1l0.3,0.5l-1.1,1.9l1,1l1.9-1.1l0.5,0.3c0.3,0.2,0.7,0.3,1.1,0.4l0.5,0.2L17.3,26.1z M27.1,19.5 L27.1,19.5L27.1,19.5z">
                        </path>
                        <path
                          d="M18,22.3c-2.4,0-4.3-1.9-4.3-4.3s1.9-4.3,4.3-4.3c2.4,0,4.3,1.9,4.3,4.3S20.4,22.3,18,22.3z M18,15.7 c-1.3,0-2.3,1-2.3,2.3s1,2.3,2.3,2.3c1.3,0,2.3-1,2.3-2.3S19.3,15.7,18,15.7z">
                        </path>
                        <path
                          d="M18,2c-0.6,0-1,0.4-1,1s0.4,1,1,1c7.7,0,14,6.3,14,14s-6.3,14-14,14S4,25.7,4,18c0-2.8,0.8-5.5,2.4-7.8v1.2 c0,0.6,0.4,1,1,1s1-0.4,1-1v-5h-5c-0.6,0-1,0.4-1,1s0.4,1,1,1h1.8C3.1,11.1,2,14.5,2,18c0,8.8,7.2,16,16,16s16-7.2,16-16 S26.8,2,18,2z">
                        </path>
                        <rect width="36" height="36" fill-opacity="0"></rect>
                      </g>
                    </svg>
                  </span>
                  <span class="info-icon" *ngIf="dynamicLabel['QI_TYPE'].fieldNotes"
                    [matTooltip]="dynamicLabel['QI_TYPE'].fieldNotes">
                    <img [src]="infoIconSrc" alt="note" width="18" height="18">
                  </span>
                </div>
                <mat-select matInput placeholder="Select"
                  [ngClass]="{'odd-item-mat-select': oddType == qmsService.qiDropDowns.selectedQiType}"
                  [(ngModel)]="qmsService.qiDropDowns.selectedQiType" (closed)="typeSearchText=''"
                  (click)="focusSearch('focus-type-search')" (keydown.enter)="focusSearch('focus-type-search')"
                  [disabled]="isDetailSectionFrozen || showUpdateType">
                  <input type="search" id="focus-type-search" class="dropdownsearchstyle" [(ngModel)]="typeSearchText"
                    matInput placeholder="search">
                  <mat-option [value]="null" class="unselectStyle"
                    (onSelectionChange)="onQiTypeSelect($event,null);">Un-select</mat-option>
                  <mat-option *ngFor="let item of qiTypeDropDown | assessmentSearch : typeSearchText"
                    (onSelectionChange)="onQiTypeSelect($event,item)" [value]="item.valueExp">
                    {{ item.displayExp }}
                  </mat-option>
                </mat-select>
              </div>
              <div class="col-md-6" *ngIf="qmsService.activity.typeUpdateJustification">
                <div>
                  <label for="email" id="justification">
                    {{dynamicLabel['CHANGE_TYPE_CODE']?.fieldName}}&nbsp;{{dynamicLabel['TYPE_UPDATE_JUSTIFICATION']?.fieldName}}
                  </label> <span class="mandatory-symbol">*</span>
                </div>
                <textarea type="text" class="input-filed-textarea" rows="4" cols="50"
                  (ngModelChange)="onNgModelChange($event,'justification')" [disabled]="true"
                  [(ngModel)]="qmsService.activity.typeUpdateJustification"
                  (input)="limitCharacters($event, 'TYPE_UPDATE_JUSTIFICATION')"></textarea>
              </div>
              <div class="col-md-2" [hidden]="dynamicLabel['DEPT_NAME'].isRemovable == 'Y'">
                <div>
                  <!-- Department -->
                  <label for="department" id="department-validation">
                    {{dynamicLabel['DEPT_NAME'].fieldName}}
                  </label> <span class="mandatory-symbol">*</span>
                  <span class="info-icon" *ngIf="dynamicLabel['DEPT_NAME'].fieldNotes"
                    [matTooltip]="dynamicLabel['DEPT_NAME'].fieldNotes">
                    <img [src]="infoIconSrc" alt="note" width="18" height="18">
                  </span>
                </div>
                <mat-select matInput placeholder="Select"
                  [ngClass]="{'odd-item-mat-select': oddDepartment == qmsService.qiDropDowns.selectedQiDepartment}"
                  [(ngModel)]="qmsService.qiDropDowns.selectedQiDepartment" [disabled]="isDetailSectionFrozen"
                  (closed)="departmentSearchText=''" (click)="focusSearch('focus-department-search')"
                  (keydown.enter)="focusSearch('focus-department-search')">
                  <input type="search" id="focus-department-search" class="dropdownsearchstyle"
                    [(ngModel)]="departmentSearchText" matInput placeholder="search">
                  <mat-option [value]="null" class="unselectStyle"
                    (onSelectionChange)="onDepartmentSelect($event,null);">Un-select</mat-option>
                  <mat-option *ngFor="let item of departmentCodeDropdown | assessmentSearch : departmentSearchText"
                    (onSelectionChange)="onDepartmentSelect($event,item)" [value]="item.valueExp">
                    {{ item.displayExp }}
                  </mat-option>
                </mat-select>
              </div>
              <div class="col-md-2">
                <div>
                  <!-- Reference -->
                  <label for="reference" id="reference-validation">
                    {{dynamicLabel['REFERENCE'].fieldName}}
                  </label> <span class="mandatory-symbol">*</span>
                  <span class="info-icon" *ngIf="dynamicLabel['REFERENCE'].fieldNotes"
                    [matTooltip]="dynamicLabel['REFERENCE'].fieldNotes">
                    <img [src]="infoIconSrc" alt="note" width="18" height="18">
                  </span>
                </div>
                <mat-select matInput placeholder="Select"
                  [ngClass]="{'odd-item-mat-select': oddReference == qmsService.qiDropDowns.selectedQiReference}"
                  [(ngModel)]="qmsService.qiDropDowns.selectedQiReference" (closed)="referenceSearchText=''"
                  (click)="focusSearch('focus-reference-search')"
                  (keydown.enter)="focusSearch('focus-reference-search')" [disabled]="isDetailSectionFrozen">
                  <input type="search" id="focus-reference-search" class="dropdownsearchstyle"
                    [(ngModel)]="referenceSearchText" matInput placeholder="search">
                  <mat-option [value]="null" class="unselectStyle"
                    (onSelectionChange)="onReferenceSelect($event,null);">Un-select</mat-option>
                  <mat-option *ngFor="let item of qualityReferenceDropdown | assessmentSearch : referenceSearchText"
                    (onSelectionChange)="onReferenceSelect($event,item)" [value]="item.valueExp">
                    {{ item.displayExp }}
                  </mat-option>
                </mat-select>
              </div>
              <div class="col-md-4" *ngIf="visibleReferenceIfOthers">
                <div>
                  <!-- Reference if Others -->
                  <label for="reference-others" id="reference-others-validation">Reference If
                    Others</label>
                  <span class="mandatory-symbol">*</span>
                </div>
                <textarea id="referenceOthers" type="text" class="input-filed-textarea" style="margin-top: 8px;"
                  rows="4" cols="50" [disabled]="isDetailSectionFrozen"
                  (input)="limitCharacters($event, 'REFERENCE_OTHERS')"
                  [(ngModel)]="qmsService.activity.referenceOthers"
                  (ngModelChange)="onNgModelChange($event,'reference-others-validation')"></textarea>
              </div>
              <div class="col-md-2">
                <div>
                  <!-- Requested At -->
                  <label id="requested-at-validation" for="requested-at">
                    {{dynamicLabel['REQUESTED_AT'].fieldName}}
                  </label> <span class="mandatory-symbol">*</span>
                  <span class="info-icon" *ngIf="dynamicLabel['REQUESTED_AT'].fieldNotes"
                    [matTooltip]="dynamicLabel['REQUESTED_AT'].fieldNotes">
                    <img [src]="infoIconSrc" alt="note" width="18" height="18">
                  </span>
                </div>
                <mat-select matInput placeholder="Select"
                  [ngClass]="{'odd-item-mat-select': oddRequestedAt == qmsService.qiDropDowns.selectedQiRequestedAt}"
                  [(ngModel)]="qmsService.qiDropDowns.selectedQiRequestedAt" (closed)="requestedSearchText=''"
                  (click)="focusSearch('focus-requested-search')" [disabled]="isDetailSectionFrozen"
                  (keydown.enter)="focusSearch('focus-requested-search')">
                  <input type="search" id="focus-requested-search" class="dropdownsearchstyle"
                    [(ngModel)]="requestedSearchText" matInput placeholder="search">
                  <mat-option [value]="null" class="unselectStyle"
                    (onSelectionChange)="onRequestedAtSelect($event,null);">Un-select</mat-option>
                  <mat-option *ngFor="let item of requestedAtDropdown | assessmentSearch : requestedSearchText"
                    (onSelectionChange)="onRequestedAtSelect($event,item)" [value]="item.valueExp">
                    {{ item.displayExp }}
                  </mat-option>
                </mat-select>
              </div>
              <div class="col-md-4" *ngIf="qmsService.qiDropDowns.selectedQiRequestedAt">
                <div>
                  <label id="core-business-area-validation" for="core-business-area">
                    {{((this.businessAreaName ?? ' ') + ' ' + dynamicLabel['CORE_BUSINESS_AREA_NAME']?.fieldName)}}
                  </label><span class="mandatory-symbol">*</span>
                </div>
                <mat-select matInput multiple placeholder="Select" #businessArea *ngIf="!isBusinessAreaEmpty"
                  [matTooltip]="qmsService.qiDropDowns.selectedQiCoreBusinessArea"
                  [(ngModel)]="qmsService.qiDropDowns.selectedQiCoreBusinessArea" (closed)="coreBusinessSearchText=''"
                  (click)="focusSearch('focus-b-area-search')" [disabled]="isDetailSectionFrozen"
                  (keydown.enter)="focusSearch('focus-b-area-search')">
                  <input type="search" id="focus-b-area-search" class="dropdownsearchstyle"
                    [(ngModel)]="coreBusinessSearchText" matInput placeholder="search">
                  <div class="select-all">
                    <mat-checkbox [(ngModel)]="isAllBusinessAreaSelected"
                      (change)="toggleAllSelection('businessArea')">Select All</mat-checkbox>
                  </div>
                  <mat-option
                    *ngFor="let item1 of coreBusinessAreaNameDropdown| multiAssessmentSearchPipe :coreBusinessSearchText"
                    [value]="item1.valueExp" (onSelectionChange)="onCoreBusinessAreaNameSelect($event,item1)">
                    {{ item1.displayExp }}
                  </mat-option>
                </mat-select>
                <textarea type="text" class="input-filed-textarea" rows="4" cols="50" *ngIf="isBusinessAreaEmpty"
                  (input)="limitCharacters($event, 'REQUESTED_AT')"
                  [(ngModel)]="qmsService.qiDropDowns.selectedQiCoreBusinessArea"
                  (ngModelChange)="onNgModelChange($event,'business-area-validation')"></textarea>
              </div>
              <div class="col-md-2">
                <div>
                  <!-- Evaluator -->
                  <label id="evaluator-validation" for="evaluator">
                    {{dynamicLabel['EVALUATOR_USER'].fieldName}}
                  </label>
                  <label for="email" *ngIf="message.showSwitchUser && setSwitchUserAesthetic(qi.status,'evaluator')">
                    <a (click)="openSwitchUser('Evaluator')">
                      <img title="Switch User" src="..//..//../assets/img/user-switch.png" alt="Switch User" width="25"
                        height="25">
                    </a>
                  </label> <span class="mandatory-symbol">*</span>
                  <span class="info-icon" *ngIf="dynamicLabel['EVALUATOR_USER'].fieldNotes"
                    [matTooltip]="dynamicLabel['EVALUATOR_USER'].fieldNotes">
                    <img [src]="infoIconSrc" alt="note" width="18" height="18">
                  </span>
                </div>
                <mat-select matInput placeholder="Select"
                  [ngClass]="{'odd-item-mat-select': oddEvaluator == qmsService.qiDropDowns.selectedQiEvaluator}"
                  [(ngModel)]="qmsService.qiDropDowns.selectedQiEvaluator" (closed)="evaluatorSearchText=''"
                  (click)="focusSearch('focus-evaluator-search')" [disabled]="isDetailSectionFrozen"
                  (keydown.enter)="focusSearch('focus-evaluator-search')">
                  <input type="search" id="focus-evaluator-search" class="dropdownsearchstyle"
                    [(ngModel)]="evaluatorSearchText" matInput placeholder="search">
                  <mat-option [value]="null" class="unselectStyle">Un-select</mat-option>
                  <mat-option *ngFor="let item of evaluatorDropDown | assessmentSearch : evaluatorSearchText"
                    [value]="item.valueExp">
                    {{ item.displayExp }}
                  </mat-option>
                </mat-select>
              </div>
              <div class="col-md-2" *ngIf="qmsService.activity.evaluationRejectReason">
                <div>
                  <!-- Evaluation Reject Reason -->
                  <label for="evaluation-reject-reason">
                    {{dynamicLabel['EVALUATION_REJECT_REASON'].fieldName}}
                  </label>
                  <span class="info-icon" *ngIf="dynamicLabel['EVALUATION_REJECT_REASON'].fieldNotes"
                    [matTooltip]="dynamicLabel['EVALUATION_REJECT_REASON'].fieldNotes">
                    <img [src]="infoIconSrc" alt="note" width="18" height="18">
                  </span>
                </div>
                <input id="evaluation-reject-reason" class="input-filed-continers disabled-input" type="text"
                  [(ngModel)]="qmsService.activity.evaluationRejectReason"
                  [matTooltip]="qmsService.activity.evaluationRejectReason" [disabled]="true">
              </div>
              <div class="col-md-4">
                <div>
                  <!-- Short Description -->
                  <label id="short-description-validation" for="short-description">
                    {{dynamicLabel['SHORT_DESCRIPTION'].fieldName}}
                  </label> <span class="mandatory-symbol">*</span>
                  <span class="info-icon" *ngIf="dynamicLabel['SHORT_DESCRIPTION'].fieldNotes"
                    [matTooltip]="dynamicLabel['SHORT_DESCRIPTION'].fieldNotes">
                    <img [src]="infoIconSrc" alt="note" width="18" height="18">
                  </span>
                </div>
                <input class="input-filed-continers" type="text" autocomplete="off"
                  [matTooltip]="qmsService.activity.shortDescription"
                  (input)="limitCharacters($event, 'SHORT_DESCRIPTION')"
                  [(ngModel)]="qmsService.activity.shortDescription"
                  (ngModelChange)="onNgModelChange($event,'short-description-validation')"
                  [disabled]="isDetailSectionFrozen">
              </div>
              <div class="col-md-4" *ngIf="qmsService.activity">
                <div>
                  <!-- Description -->
                  <label id="description-validation" for="description">
                    {{dynamicLabel['DESCRIPTION'].fieldName}}
                  </label>
                  <span *ngIf="qmsService.validateQiAntiDraftFields" class="mandatory-symbol">*</span>
                  <span class="info-icon" *ngIf="dynamicLabel['DESCRIPTION'].fieldNotes"
                    [matTooltip]="dynamicLabel['DESCRIPTION'].fieldNotes">
                    <img [src]="infoIconSrc" alt="note" width="18" height="18">
                  </span>
                </div>
                <div class="row">
                  <div class="hideToolbar col-sm-11">
                    <st-editor [disabled]="isDetailSectionFrozen" [(ngModel)]="qmsService.activity.description"
                      [config]="config" [spellcheck]="true"
                      (ngModelChange)="qmsService.validateQiAntiDraftFields ? onStEditorChange($event,'description-validation') : null"
                      (paste)="onPaste($event)"></st-editor>
                  </div>
                  <div class="col-sm-1 angular-editor-edit"
                    (keydown.enter)="isDetailSectionFrozen ? openEditor('Description', 'eye') : openEditor('Description', 'edit')"
                    (click)="isDetailSectionFrozen ? openEditor('Description', 'eye') : openEditor('Description', 'edit')">
                    <i *ngIf="!isDetailSectionFrozen" class="far fa-edit"></i>
                    <i *ngIf="isDetailSectionFrozen" class="fa fa-eye eye"></i>
                  </div>
                </div>
              </div>
              <div class="col-md-2">
                <div>
                  <!-- Impact Type -->
                  <label id="impact-type-validation" for="impact-type">
                    {{dynamicLabel['IMPACT_TYPE'].fieldName}}
                  </label>
                  <span *ngIf="qmsService.validateQiAntiDraftFields" class="mandatory-symbol">*</span>
                  <span class="info-icon" *ngIf="dynamicLabel['IMPACT_TYPE'].fieldNotes"
                    [matTooltip]="dynamicLabel['IMPACT_TYPE'].fieldNotes">
                    <img [src]="infoIconSrc" alt="note" width="18" height="18">
                  </span>
                </div>
                <mat-select matInput placeholder="Select"
                  [ngClass]="{'odd-item-mat-select': oddImpactType == qmsService.qiDropDowns.selectedQiImpactType}"
                  [(ngModel)]="qmsService.qiDropDowns.selectedQiImpactType" (closed)="impactTypeSearchText=''"
                  (click)="focusSearch('focus-impact-search')" [disabled]="isDetailSectionFrozen"
                  (keydown.enter)="focusSearch('focus-impact-search')">
                  <input type="search" id="focus-impact-search" class="dropdownsearchstyle"
                    [(ngModel)]="impactTypeSearchText" matInput placeholder="search">
                  <mat-option [value]="null" class="unselectStyle"
                    (onSelectionChange)="onImpactTypeSelect($event,null);">Un-select</mat-option>
                  <mat-option *ngFor="let item of impactTypeDropdown | assessmentSearch : impactTypeSearchText"
                    (onSelectionChange)="onImpactTypeSelect($event,item)" [value]="item.valueExp">
                    {{ item.displayExp }}
                  </mat-option>
                </mat-select>
              </div>
              <div class="col-md-2" *ngIf="this.qmsService.selectedGroupDetailData.isRiskCalculationReqd=='Y'">
                <div>
                  <!-- Is Risk Calculation Reqd? -->
                  <label for="risk-reqd">
                    {{dynamicLabel['IS_RISK_CALCULATION_REQD'].fieldName}}
                  </label>
                  <span class="info-icon" *ngIf="dynamicLabel['IS_RISK_CALCULATION_REQD'].fieldNotes"
                    [matTooltip]="dynamicLabel['IS_RISK_CALCULATION_REQD'].fieldNotes">
                    <img [src]="infoIconSrc" alt="note" width="18" height="18">
                  </span>
                </div>
                <mat-slide-toggle color="primary" [(ngModel)]="qmsService.activity.isRiskCalculationReqd"
                  [disabled]="isDetailSectionFrozen && !elite_Action_EC_Risk">
                  <ng-container *ngIf="qmsService.activity.isRiskCalculationReqd; else no">
                    <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
                  </ng-container>
                  <ng-template #no>
                    <span style="color: red;">No</span>
                  </ng-template>
                </mat-slide-toggle>
              </div>

              <div class="col-md-2 d-flex align-items-center" *ngIf="qmsService.selectedGroupDetailData.isRiskCalculationReqd == 'Y'
            && qmsService.activity.isRiskCalculationReqd && qmsService.activity.finalRiskScore">

                <div class="d-flex align-items-center gap-4">
                  <div class="qms-risk-icon" [matTooltip]="'Risk Status : ' + qmsService.activity.finalRiskStatus">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
                      stroke="#0f3659">
                      <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                      <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                      <g id="SVGRepo_iconCarrier">
                        <path d="M6.87988 18.1501V16.0801" stroke="#0f3659" stroke-width="1.5" stroke-linecap="round">
                        </path>
                        <path d="M12 18.15V14.01" stroke="#0f3659" stroke-width="1.5" stroke-linecap="round"></path>
                        <path d="M17.1201 18.1499V11.9299" stroke="#0f3659" stroke-width="1.5" stroke-linecap="round">
                        </path>
                        <path d="M17.1199 5.8501L16.6599 6.3901C14.1099 9.3701 10.6899 11.4801 6.87988 12.4301"
                          stroke="#0f3659" stroke-width="1.5" stroke-linecap="round"></path>
                        <path d="M14.1899 5.8501H17.1199V8.7701" stroke="#0f3659" stroke-width="1.5"
                          stroke-linecap="round" stroke-linejoin="round">
                        </path>
                        <path d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
                          stroke="#0f3659" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                      </g>
                    </svg>
                  </div>

                  <div class="qms-risk-icon" [matTooltip]="'Navigate to Risk Assessment'" (click)="navigateToRisk()"
                    (keydown.enter)="navigateToRisk()">
                    <svg width="20" height="20" fill="#0f3659" viewBox="0 0 35 35" data-name="Layer 2" id="Layer_2"
                      xmlns="http://www.w3.org/2000/svg">
                      <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                      <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                      <g id="SVGRepo_iconCarrier">
                        <path
                          d="M21.81,34.75H21.5A3.8,3.8,0,0,1,18,31.58L16,20.12A1.36,1.36,0,0,0,14.88,19L3.42,17a3.84,3.84,0,0,1-.56-7.42L29.66.46h0a3.84,3.84,0,0,1,4.88,4.88l-9.11,26.8A3.79,3.79,0,0,1,21.81,34.75ZM30.47,2.83,3.66,11.94a1.34,1.34,0,0,0,.2,2.59l11.46,2a3.85,3.85,0,0,1,3.11,3.11l2,11.46a1.34,1.34,0,0,0,2.59.2L32.17,4.53a1.34,1.34,0,0,0-1.7-1.7Z">
                        </path>
                      </g>
                    </svg>
                  </div>
                </div>
              </div>

              <div class="col-md-4" *ngIf="qmsService.activity">
                <div>
                  <!-- Impact Description -->
                  <label id="impact-description-validation" for="impact-description">
                    {{dynamicLabel['IMPACT_DESCRIPTION'].fieldName}}
                  </label>
                  <span *ngIf="qmsService.validateQiAntiDraftFields" class="mandatory-symbol">*</span>
                  <span class="info-icon" *ngIf="dynamicLabel['IMPACT_DESCRIPTION'].fieldNotes"
                    [matTooltip]="dynamicLabel['IMPACT_DESCRIPTION'].fieldNotes">
                    <img [src]="infoIconSrc" alt="note" width="18" height="18">
                  </span>
                </div>
                <div class="row">
                  <div class="hideToolbar col-sm-11">
                    <st-editor [disabled]="isDetailSectionFrozen" [(ngModel)]="qmsService.activity.impactDescription"
                      [config]="config" [spellcheck]="true"
                      (ngModelChange)="qmsService.validateQiAntiDraftFields ? onStEditorChange($event,'impact-description-validation') : null"
                      (paste)="onPaste($event)"></st-editor>
                  </div>
                  <div class="col-sm-1 angular-editor-edit"
                    (keydown.enter)="isDetailSectionFrozen ? openEditor('Impact Description', 'eye') : openEditor('Impact Description', 'edit')"
                    (click)="isDetailSectionFrozen ? openEditor('Impact Description', 'eye') : openEditor('Impact Description', 'edit')">
                    <i *ngIf="!isDetailSectionFrozen" class="far fa-edit"></i>
                    <i *ngIf="isDetailSectionFrozen" class="fa fa-eye eye"></i>
                  </div>
                </div>
              </div>
              <div class="col-md-2"
                *ngIf="qmsService.activity.status != 'Draft' && qmsService.activity.status != 'Deleted' && qmsService.activity.status != 'Raised'">
                <div>
                  <!-- Action Items Required? -->
                  <label for="action-items">{{dynamicLabel['ACTION_ITEMS_REQD'].fieldName}}</label>
                  <span class="info-icon" *ngIf="dynamicLabel['ACTION_ITEMS_REQD'].fieldNotes"
                    [matTooltip]="dynamicLabel['ACTION_ITEMS_REQD'].fieldNotes">
                    <img [src]="infoIconSrc" alt="note" width="18" height="18">
                  </span>
                </div>
                <mat-slide-toggle color="primary" name="actionItemsReqd"
                  [disabled]="isDetailSectionFrozen && !elite_Action_EC_Risk"
                  [(ngModel)]="qmsService.activity.actionItemsReqd">
                  <ng-container *ngIf="qmsService.activity.actionItemsReqd; else no">
                    <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
                  </ng-container>
                  <ng-template #no>
                    <span style="color: red;">No</span>
                  </ng-template>
                </mat-slide-toggle>
              </div>
              <div class="col-md-2" *ngIf="qmsService.selectedGroupDetailData.preliminaryActionEnabled == 'Y'">
                <div>
                  <label for="email ">
                    {{dynamicLabel['PRE_ACTION_ITEMS_REQD']?.fieldName}}
                  </label>
                  <span style="float:right" *ngIf="dynamicLabel['PRE_ACTION_ITEMS_REQD']?.fieldNotes"
                    [matTooltip]="dynamicLabel['PRE_ACTION_ITEMS_REQD']?.fieldNotes">
                    <img [src]="qmsService.noteIcon" alt="note" width="18" height="18">
                  </span>
                </div>
                <mat-slide-toggle color="primary" [(ngModel)]="qmsService.activity.preActionItemsReqd"
                  [disabled]="isDetailSectionFrozen && !elite_Action_EC_Risk">
                  <span class="active-inActive-container"
                    [ngStyle]="{ color: qmsService.activity.preActionItemsReqd ? 'green' : 'red' }">
                    {{ qmsService.activity.preActionItemsReqd ? 'Yes' : 'No' }}
                  </span>
                </mat-slide-toggle>
              </div>
              <div class="col-md-2" *ngIf="qmsService.selectedGroupDetailData.effectivenessCheckEnabled == 'Y'">
                <div>
                  <!-- Is Effectiveness Check Mandatory? -->
                  <label for="ec-reqd">{{dynamicLabel['EFFECTIVENESS_CHECK_REQD'].fieldName}}</label>
                  <span class="info-icon" *ngIf="dynamicLabel['EFFECTIVENESS_CHECK_REQD'].fieldNotes"
                    [matTooltip]="dynamicLabel['EFFECTIVENESS_CHECK_REQD'].fieldNotes">
                    <img [src]="infoIconSrc" alt="note" width="18" height="18">
                  </span>
                </div>
                <mat-slide-toggle color="primary" [disabled]="isDetailSectionFrozen && !elite_Action_EC_Risk"
                  [(ngModel)]="qmsService.activity.effectivenessCheckReqd">
                  <ng-container *ngIf="qmsService.activity.effectivenessCheckReqd; else no">
                    <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
                  </ng-container>
                  <ng-template #no>
                    <span style="color: red;">No</span>
                  </ng-template>
                </mat-slide-toggle>
              </div>
              <div class="col-md-3">
                <div>
                  <!-- Users to be Intimated Post Evaluation? -->
                  <label for="intimate-post-evaluation">
                    {{dynamicLabel['USERS_TO_BE_INTIMATED_POST_EVALUATION'].fieldName}}
                  </label>
                  <span class="info-icon" *ngIf="dynamicLabel['USERS_TO_BE_INTIMATED_POST_EVALUATION'].fieldNotes"
                    [matTooltip]="dynamicLabel['USERS_TO_BE_INTIMATED_POST_EVALUATION'].fieldNotes">
                    <img [src]="infoIconSrc" alt="note" width="18" height="18">
                  </span>
                </div>
                <mat-slide-toggle color="primary" name="usersToBeIntimatedPostEvaluation"
                  [disabled]="isDetailSectionFrozen" [(ngModel)]="qmsService.activity.usersToBeIntimatedPostEvaluation">
                  <ng-container *ngIf="qmsService.activity.usersToBeIntimatedPostEvaluation; else no">
                    <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
                  </ng-container>
                  <ng-template #no>
                    <span style="color: red;">No</span>
                  </ng-template>
                </mat-slide-toggle>
              </div>
            </div>
          </fieldset>

          <fieldset class="border p-2 fieldsetStyle">
            <legend class="float-none w-auto p-2">
              <span class="" style="font-size: 14px;color: #cfcfcf;">Date</span>
            </legend>

            <div class="row">
              <div class="col-md-2">
                <div>
                  <!-- Initiated On -->
                  <label for="created-on">{{dynamicLabel['CREATED_ON'].fieldName}}</label>
                  <span class="info-icon" *ngIf="dynamicLabel['CREATED_ON'].fieldNotes"
                    [matTooltip]="dynamicLabel['CREATED_ON'].fieldNotes">
                    <img [src]="infoIconSrc" alt="note" width="18" height="18">
                  </span>
                </div>
                <input id="created-on" type="text" class="form-control data-picker-continer disabled-input" bsDatepicker
                  [bsConfig]="dateTimeConfig" [dateCustomClasses]="dateCustomClasses"
                  [(ngModel)]="qmsService.activity.createdOn" disabled>
              </div>
              <div class="col-md-2">
                <div>
                  <!-- Identified On -->
                  <label id="identified-on-validation" for="identified-on">
                    {{dynamicLabel['IDENTIFIED_ON'].fieldName}}
                  </label> <span class="mandatory-symbol">*</span>
                  <span class="info-icon" *ngIf="dynamicLabel['IDENTIFIED_ON'].fieldNotes"
                    [matTooltip]="dynamicLabel['IDENTIFIED_ON'].fieldNotes">
                    <img [src]="infoIconSrc" alt="note" width="18" height="18">
                  </span>
                </div>
                <input id="identified-on" type="text" class="form-control data-picker-continer" bsDatepicker
                  [bsConfig]="identifiedOnConfig" [dateCustomClasses]="dateCustomClasses"
                  [(ngModel)]="qmsService.activity.identifiedOn" [disabled]="isDateSectionFrozen"
                  (ngModelChange)="onNgModelChange($event,'identified-on-validation')">
              </div>
              <div class="col-md-2" [hidden]="this.dynamicLabel['EXPECTED_TO_BE_STARTED_ON'].isRemovable == 'Y'">
                <div>
                  <!-- Expected to be Started On -->
                  <label id="expected-to-be-started-on-validation" for="expected-to-be-started-on">
                    {{dynamicLabel['EXPECTED_TO_BE_STARTED_ON'].fieldName}}
                  </label> <span class="mandatory-symbol">*</span>
                  <span class="info-icon" *ngIf="dynamicLabel['EXPECTED_TO_BE_STARTED_ON'].fieldNotes"
                    [matTooltip]="dynamicLabel['EXPECTED_TO_BE_STARTED_ON'].fieldNotes">
                    <img [src]="infoIconSrc" alt="note" width="18" height="18">
                  </span>
                </div>
                <input id="expected-to-be-started-on" type="text" class="form-control data-picker-continer" bsDatepicker
                  [bsConfig]="expectedToBeStartedOnConfig" [dateCustomClasses]="dateCustomClasses"
                  [(ngModel)]="qmsService.activity.expectedToBeStartedOn"
                  (ngModelChange)="onNgModelChange($event, 'expected-to-be-started-on-validation'); onExpectedToBeStartedOnChange()"
                  [disabled]="isDateSectionFrozen">
              </div>
              <div class="col-md-2" *ngIf="qmsService.activity.startedOn">
                <div> <label for="started-on">Started On</label></div>
                <input id="started-on" type="text" class="form-control data-picker-continer disabled-input" bsDatepicker
                  [bsConfig]="dateTimeConfig" [dateCustomClasses]="dateCustomClasses"
                  [(ngModel)]="qmsService.activity.startedOn" disabled>
              </div>
              <div class="col-md-2">
                <div>
                  <!-- Expected Closure Date -->
                  <label id="expected-closure-on-validation" for="expected-closure-on">
                    {{dynamicLabel['EXPCETED_CLOSURE_ON'].fieldName}}
                  </label> <span class="mandatory-symbol">*</span>
                  <span class="info-icon" *ngIf="dynamicLabel['EXPCETED_CLOSURE_ON'].fieldNotes"
                    [matTooltip]="dynamicLabel['EXPCETED_CLOSURE_ON'].fieldNotes">
                    <img [src]="infoIconSrc" alt="note" width="18" height="18">
                  </span>
                </div>
                <input id="expected-closure-on" type="text" class="form-control data-picker-continer" bsDatepicker
                  [bsConfig]="generateExpectedClosureDateConfig()" [dateCustomClasses]="dateCustomClasses"
                  [(ngModel)]="qmsService.activity.expcetedClosureOn"
                  (ngModelChange)="onNgModelChange($event, 'expected-closure-on-validation')"
                  [disabled]="isDateSectionFrozen">
              </div>
              <div class="col-md-2" *ngIf="qmsService.activity.completedOn">
                <div><label for="completed-on">Completed On</label></div>
                <input id="completed-on" type="text" class="form-control data-picker-continer disabled-input"
                  bsDatepicker [bsConfig]="dateTimeConfig" [dateCustomClasses]="dateCustomClasses"
                  [(ngModel)]="qmsService.activity.completedOn" disabled>
              </div>
            </div>
          </fieldset>

          <fieldset class="border p-2 fieldsetStyle" *ngIf="this.message.showQiLoggingSection">
            <legend class="float-none w-auto p-2">
              <span class="" style="font-size: 14px;color: #cfcfcf;">{{qmsService.moduleFullName}}&nbsp;Logging</span>
            </legend>
            <div class="row">
              <div class="col-md-4" [hidden]="dynamicLabel['ASSESSMENT_COMMENT'].isRemovable == 'Y'">
                <div>
                  <!-- Assessment Comments -->
                  <label id="assessment-comments-validation" for="assessment-comments">
                    {{dynamicLabel['ASSESSMENT_COMMENT'].fieldName}}
                  </label> <span class="mandatory-symbol">*</span>
                  <span class="info-icon" *ngIf="dynamicLabel['ASSESSMENT_COMMENT'].fieldNotes"
                    [matTooltip]="dynamicLabel['ASSESSMENT_COMMENT'].fieldNotes">
                    <img [src]="infoIconSrc" alt="note" width="18" height="18">
                  </span>
                </div>
                <textarea id="assessmentComment" type="text" class="input-filed-textarea" style="margin-top: 8px;"
                  rows="4" cols="50" [disabled]="isLoggingSectionFrozen"
                  (input)="limitCharacters($event, 'ASSESSMENT_COMMENT')"
                  [(ngModel)]="qmsService.activity.assessmentComment"
                  (ngModelChange)="onNgModelChange($event, 'assessment-comments-validation')"></textarea>
              </div>
              <div class="col-md-2" *ngIf="qmsService.activity.qaUser != 0">
                <div>
                  <!-- QA -->
                  <label id="qa-validation" for="qa">
                    {{dynamicLabel['QA_USR_USER_NAME'].fieldName}}
                  </label>
                  <label for="qa-swtich" *ngIf="message.showSwitchUser && setSwitchUserAesthetic(qi.status,'qa')">
                    <a (click)="openSwitchUser('QA')">
                      <img title="Switch User" src="..//..//../assets/img/user-switch.png" alt="Switch User" width="25"
                        height="25">
                    </a>
                  </label> <span class="mandatory-symbol">*</span>
                  <span class="info-icon" *ngIf="dynamicLabel['QA_USR_USER_NAME'].fieldNotes"
                    [matTooltip]="dynamicLabel['QA_USR_USER_NAME'].fieldNotes">
                    <img [src]="infoIconSrc" alt="note" width="18" height="18">
                  </span>
                </div>
                <mat-select matInput placeholder="Select"
                  [ngClass]="{'odd-item-mat-select': oddQA == qmsService.qiDropDowns.selectedQiQa}"
                  [(ngModel)]="qmsService.qiDropDowns.selectedQiQa" (closed)="qaSearchText=''"
                  (click)="focusSearch('focus-qa-search')" (keydown.enter)="focusSearch('focus-qa-search')"
                  [disabled]="isLoggingSectionFrozen || qmsService.activity.status == 'Investigator Requested More Information'">
                  <input type="search" id="focus-qa-search" class="dropdownsearchstyle" [(ngModel)]="qaSearchText"
                    matInput placeholder="search">
                  <mat-option [value]="null" class="unselectStyle"
                    (onSelectionChange)="onImpactTypeSelect($event,null);">Un-select</mat-option>
                  <mat-option *ngFor="let item of qaDropDown | assessmentSearch : qaSearchText"
                    (onSelectionChange)="onImpactTypeSelect($event,item)" [value]="item.valueExp">
                    {{ item.displayExp }}
                  </mat-option>
                </mat-select>
              </div>
              <div class="col-md-2" *ngIf="qmsService.activity.qaApprovalRequestedOn">
                <div>
                  <label for="status">{{dynamicLabel['QA_APPROVAL_REQUESTED_ON'].fieldName}}</label>
                  <span class="info-icon" *ngIf="dynamicLabel['QA_APPROVAL_REQUESTED_ON'].fieldNotes"
                    [matTooltip]="dynamicLabel['QA_APPROVAL_REQUESTED_ON'].fieldNotes">
                    <img [src]="infoIconSrc" alt="note" width="18" height="18">
                  </span>
                </div>
                <input id="investigation-requested-on" type="text"
                  class="form-control data-picker-continer disabled-input" bsDatepicker [bsConfig]="dateTimeConfig"
                  [dateCustomClasses]="dateCustomClasses" [(ngModel)]="qmsService.activity.qaApprovalRequestedOn"
                  [disabled]="true">
              </div>
              <div class="col-md-2" *ngIf="qmsService.activity.qaApprovedOn">
                <div>
                  <label for="status">{{dynamicLabel['QA_APPROVED_ON'].fieldName}}</label>
                  <span class="info-icon" *ngIf="dynamicLabel['QA_APPROVED_ON'].fieldNotes"
                    [matTooltip]="dynamicLabel['QA_APPROVED_ON'].fieldNotes">
                    <img [src]="infoIconSrc" alt="note" width="18" height="18">
                  </span>
                </div>
                <input type="text" class="form-control data-picker-continer disabled-input" bsDatepicker
                  [bsConfig]="dateTimeConfig" [dateCustomClasses]="dateCustomClasses"
                  [(ngModel)]="qmsService.activity.qaApprovedOn" [disabled]="true">
              </div>
              <div class="col-md-2"
                *ngIf="qmsService.activity.qaRejectedOn && qmsService.activity.status =='QA Rejected'">
                <div>
                  <label for="status">{{dynamicLabel['QA_REJECTED_ON'].fieldName}}</label>
                  <span class="info-icon" *ngIf="dynamicLabel['QA_REJECTED_ON'].fieldNotes"
                    [matTooltip]="dynamicLabel['QA_REJECTED_ON'].fieldNotes">
                    <img [src]="infoIconSrc" alt="note" width="18" height="18">
                  </span>
                </div>
                <input type="text" class="form-control data-picker-continer disabled-input" bsDatepicker
                  [bsConfig]="dateTimeConfig" [dateCustomClasses]="dateCustomClasses"
                  [(ngModel)]="qmsService.activity.qaRejectedOn" [disabled]="true">
              </div>
              <div class="col-md-2"
                *ngIf="qmsService.activity.qaRejectedComments && qmsService.activity.status =='QA Rejected'">
                <div>
                  <label for="status">{{dynamicLabel['QA_REJECTED_COMMENTS'].fieldName}}</label>
                  <span class="info-icon" *ngIf="dynamicLabel['QA_REJECTED_COMMENTS'].fieldNotes"
                    [matTooltip]="dynamicLabel['QA_REJECTED_COMMENTS'].fieldNotes">
                    <img [src]="infoIconSrc" alt="note" width="18" height="18">
                  </span>
                </div>
                <textarea type="text" class="input-filed-textarea" rows="4" cols="50"
                  [(ngModel)]="qmsService.activity.qaRejectedComments" [disabled]="true"></textarea>
              </div>
              <div class="col-md-2" *ngIf="qmsService.activity.qaComments">
                <div>
                  <!-- Status -->
                  <label for="status">{{dynamicLabel['QA_COMMENTS'].fieldName}}</label>
                  <span class="info-icon" *ngIf="dynamicLabel['QA_COMMENTS'].fieldNotes"
                    [matTooltip]="dynamicLabel['QA_COMMENTS'].fieldNotes">
                    <img [src]="infoIconSrc" alt="note" width="18" height="18">
                  </span>
                </div>
                <textarea type="text" class="input-filed-textarea" rows="4" cols="50"
                  [(ngModel)]="qmsService.activity.qaComments" [disabled]="true"></textarea>
              </div>
              <div class="col-md-2">
                <div>
                  <!-- Serious Breach Assessment Form Required? -->
                  <label for="breach-assessment">
                    {{dynamicLabel['SERIOUS_BREACH_ASSESSMENT_FORM_REQUIRED'].fieldName}}
                  </label>
                  <span class="info-icon" *ngIf="dynamicLabel['SERIOUS_BREACH_ASSESSMENT_FORM_REQUIRED'].fieldNotes"
                    [matTooltip]="dynamicLabel['SERIOUS_BREACH_ASSESSMENT_FORM_REQUIRED'].fieldNotes">
                    <img [src]="infoIconSrc" alt="note" width="18" height="18">
                  </span>
                </div>
                <mat-slide-toggle color="primary" [disabled]="isLoggingSectionFrozen"
                  [(ngModel)]="qmsService.activity.seriousBreachAssessmentFormRequired">
                  <ng-container *ngIf="qmsService.activity.seriousBreachAssessmentFormRequired; else no">
                    <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
                  </ng-container>
                  <ng-template #no>
                    <span style="color: red;">No</span>
                  </ng-template>
                </mat-slide-toggle>
              </div>
              <div class="col-md-2">
                <div>
                  <!-- Investigation Required? -->
                  <label for="investigation-reqd">
                    {{dynamicLabel['INVESTIGATION_REQUIRED'].fieldName}}
                  </label>
                  <span class="info-icon" *ngIf="dynamicLabel['INVESTIGATION_REQUIRED'].fieldNotes"
                    [matTooltip]="dynamicLabel['INVESTIGATION_REQUIRED'].fieldNotes">
                    <img [src]="infoIconSrc" alt="note" width="18" height="18">
                  </span>
                </div>
                <mat-slide-toggle color="primary" name="investigationRequired1"
                  [disabled]="isLoggingSectionFrozen && !elite_Investigation"
                  [(ngModel)]="qmsService.activity.investigationRequired" (change)="onInvestigationRequiredChange()">
                  <ng-container *ngIf="qmsService.activity.investigationRequired; else no">
                    <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
                  </ng-container>
                  <ng-template #no>
                    <span style="color: red;">No</span>
                  </ng-template>
                </mat-slide-toggle>
              </div>
              <div class="col-md-2" *ngIf="qmsService.activity.investigationRequired">
                <div>
                  <!--  Investigator -->
                  <label id="investigator-validation" for="investigator">
                    {{dynamicLabel['INVESTIGATOR_USER'].fieldName}}
                  </label>
                  <label for="email" *ngIf="message.showSwitchUser && setSwitchUserAesthetic(qi.status,'investigator')">
                    <a (click)="openSwitchUser('Investigator')">
                      <img title="Switch User" src="..//..//../assets/img/user-switch.png" alt="Switch User" width="25"
                        height="25">
                    </a>
                  </label> <span class="mandatory-symbol">*</span>
                  <span class="info-icon" *ngIf="dynamicLabel['INVESTIGATOR_USER'].fieldNotes"
                    [matTooltip]="dynamicLabel['INVESTIGATOR_USER'].fieldNotes">
                    <img [src]="infoIconSrc" alt="note" width="18" height="18">
                  </span>
                </div>
                <mat-select matInput placeholder="Select"
                  [ngClass]="{'odd-item-mat-select': oddInvestigator == qmsService.qiDropDowns.selectedQiInvestigator}"
                  [(ngModel)]="qmsService.qiDropDowns.selectedQiInvestigator" (closed)="investigatorSearchText=''"
                  (click)="focusSearch('focus-investigator-search')"
                  (keydown.enter)="focusSearch('focus-investigator-search')"
                  [disabled]="isLoggingSectionFrozen && !elite_Investigation">
                  <input type="search" id="focus-investigator-search" class="dropdownsearchstyle"
                    [(ngModel)]="investigatorSearchText" matInput placeholder="search">
                  <mat-option [value]="null" class="unselectStyle"
                    (onSelectionChange)="onInvestigatorSelect($event,null);">Un-select</mat-option>
                  <mat-option *ngFor="let item of investigatorDropDown | assessmentSearch : investigatorSearchText"
                    (onSelectionChange)="onInvestigatorSelect($event,item)" [value]="item.valueExp">
                    {{ item.displayExp }}
                  </mat-option>
                </mat-select>
              </div>
              <div class="col-md-2"
                *ngIf="qmsService.activity.investigationRequired && qmsService.activity.investigationRequestedOn">
                <div>
                  <label for="status">{{dynamicLabel['INVESTIGATION_REQUESTED_ON'].fieldName}}</label>
                  <span class="info-icon" *ngIf="dynamicLabel['INVESTIGATION_REQUESTED_ON'].fieldNotes"
                    [matTooltip]="dynamicLabel['INVESTIGATION_REQUESTED_ON'].fieldNotes">
                    <img [src]="infoIconSrc" alt="note" width="18" height="18">
                  </span>
                </div>
                <input type="text" class="form-control data-picker-continer disabled-input" bsDatepicker
                  [bsConfig]="dateTimeConfig" [dateCustomClasses]="dateCustomClasses"
                  [(ngModel)]="qmsService.activity.investigationRequestedOn" [disabled]="true">
              </div>
              <div class="col-md-2"
                *ngIf="qmsService.activity.investigationRequired && qmsService.activity.investigationCompletedOn && qmsService.activity.status !='Reinvestigation Requested' && qmsService.activity.status !='Investigator Requested More Information'">
                <div>
                  <label for="status">{{dynamicLabel['INVESTIGATION_COMPLETED_ON'].fieldName}}</label>
                  <span class="info-icon" *ngIf="dynamicLabel['INVESTIGATION_COMPLETED_ON'].fieldNotes"
                    [matTooltip]="dynamicLabel['INVESTIGATION_COMPLETED_ON'].fieldNotes">
                    <img [src]="infoIconSrc" alt="note" width="18" height="18">
                  </span>
                </div>
                <input type="text" class="form-control data-picker-continer disabled-input" bsDatepicker
                  [bsConfig]="dateTimeConfig" [dateCustomClasses]="dateCustomClasses"
                  [(ngModel)]="qmsService.activity.investigationCompletedOn" [disabled]="true">
              </div>
              <div class="col-md-2"
                *ngIf="qmsService.activity.investigationRequired && qmsService.activity.investigatorComments && qmsService.activity.status !='Investigation Pending' && qmsService.activity.status !='Reinvestigation Requested' && qmsService.activity.status !='Investigator Requested More Information'">
                <div>
                  <!-- Status -->
                  <label for="status">{{dynamicLabel['INVESTIGATOR_COMMENTS'].fieldName}}</label>
                  <span class="info-icon" *ngIf="dynamicLabel['INVESTIGATOR_COMMENTS'].fieldNotes"
                    [matTooltip]="dynamicLabel['INVESTIGATOR_COMMENTS'].fieldNotes">
                    <img [src]="infoIconSrc" alt="note" width="18" height="18">
                  </span>
                </div>
                <input class="input-filed-continers disabled-input" type="text"
                  [(ngModel)]="qmsService.activity.investigatorComments" [disabled]="true">
              </div>
              <div class="col-md-2"
                *ngIf="qmsService.activity.status =='Investigator Requested More Information' && qmsService.activity.investigationRequired && qmsService.activity.investigatorMoreInfoRequestedOn">
                <div>
                  <!-- Status -->
                  <label for="status">{{dynamicLabel['INVESTIGATOR_MORE_INFO_REQUESTED_ON'].fieldName}}</label>
                  <span class="info-icon" *ngIf="dynamicLabel['INVESTIGATOR_MORE_INFO_REQUESTED_ON'].fieldNotes"
                    [matTooltip]="dynamicLabel['INVESTIGATOR_MORE_INFO_REQUESTED_ON'].fieldNotes">
                    <img [src]="infoIconSrc" alt="note" width="18" height="18">
                  </span>
                </div>
                <input class="input-filed-continers disabled-input" type="text"
                  [(ngModel)]="qmsService.activity.investigatorMoreInfoRequestedOn" [disabled]="true">
              </div>
              <div class="col-md-4"
                *ngIf="qmsService.activity.status =='Investigator Requested More Information' && qmsService.activity.investigationRequired && qmsService.activity.investigatorMoreInfoRequestedComments">
                <div>
                  <!-- Status -->
                  <label for="status">{{dynamicLabel['INVESTIGATOR_MORE_INFO_REQUESTED_COMMENTS'].fieldName}}</label>
                  <span class="info-icon" *ngIf="dynamicLabel['INVESTIGATOR_MORE_INFO_REQUESTED_COMMENTS'].fieldNotes"
                    [matTooltip]="dynamicLabel['INVESTIGATOR_MORE_INFO_REQUESTED_COMMENTS'].fieldNotes">
                    <img [src]="infoIconSrc" alt="note" width="18" height="18">
                  </span>
                  <textarea type="text" class="input-filed-textarea" rows="4" cols="50"
                    [(ngModel)]="qmsService.activity.investigatorMoreInfoRequestedComments"
                    [disabled]="true"></textarea>
                </div>
              </div>
            </div>
          </fieldset>

          <fieldset class="border p-2 fieldsetStyle" *ngIf="message.showInvestigationSection">
            <legend class="float-none w-auto p-2">
              <span class="" style="font-size: 14px;color: #cfcfcf;">Investigation</span>
            </legend>
            <div class="row">
              <div class="col-md-4" [hidden]="dynamicLabel['INVESTIGATION_SUMMARY'].isRemovable == 'Y'">
                <div>
                  <!-- Investigation Summary -->
                  <label id="investigation-summary-validation" for="investigation-summary">
                    {{dynamicLabel['INVESTIGATION_SUMMARY'].fieldName}}
                  </label> <span class="mandatory-symbol">*</span>
                  <span class="info-icon" *ngIf="dynamicLabel['INVESTIGATION_SUMMARY'].fieldNotes"
                    [matTooltip]="dynamicLabel['INVESTIGATION_SUMMARY'].fieldNotes">
                    <img [src]="infoIconSrc" alt="note" width="18" height="18">
                  </span>
                </div>
                <div class="row">
                  <div class="hideToolbar col-sm-11">
                    <st-editor [(ngModel)]="qmsService.activity.investigationSummary" [config]="config"
                      [spellcheck]="true" [disabled]="isInvestigationSectionFrozen"
                      (ngModelChange)="onStEditorChange($event, 'investigation-summary-validation')"
                      (paste)="onPaste($event)"></st-editor>
                  </div>
                  <div class="col-sm-1 angular-editor-edit"
                    (keydown.enter)="isInvestigationSectionFrozen ? openEditor('Investigation Summary', 'eye') : openEditor('Investigation Summary', 'edit')"
                    (click)="isInvestigationSectionFrozen ? openEditor('Investigation Summary', 'eye') : openEditor('Investigation Summary', 'edit')">
                    <i *ngIf="!isInvestigationSectionFrozen" class="far fa-edit"></i>
                    <i *ngIf="isInvestigationSectionFrozen" class="fa fa-eye eye"></i>
                  </div>
                </div>
              </div>
              <div class="col-md-4" [hidden]="dynamicLabel['OCCURANCE_REASON'].isRemovable == 'Y'">
                <div>
                  <!-- Occurrence Reason -->
                  <label id="occurrence-reason-validation" for="occurrence-reason">
                    {{dynamicLabel['OCCURANCE_REASON'].fieldName}}
                  </label>
                  <span class="info-icon" *ngIf="dynamicLabel['OCCURANCE_REASON'].fieldNotes"
                    [matTooltip]="dynamicLabel['OCCURANCE_REASON'].fieldNotes">
                    <img [src]="infoIconSrc" alt="note" width="18" height="18">
                  </span>
                </div>
                <div class="row">
                  <div class="hideToolbar col-sm-11">
                    <st-editor [(ngModel)]="qmsService.activity.occurrenceReason" [config]="config" [spellcheck]="true"
                      [disabled]="isInvestigationSectionFrozen" (paste)="onPaste($event)"></st-editor>
                  </div>
                  <div class="col-sm-1 angular-editor-edit"
                    (keydown.enter)="isInvestigationSectionFrozen ? openEditor('Occurrence Reason', 'eye') : openEditor('Occurrence Reason', 'edit')"
                    (click)="isInvestigationSectionFrozen ? openEditor('Occurrence Reason', 'eye') : openEditor('Occurrence Reason', 'edit')">
                    <i *ngIf="!isInvestigationSectionFrozen" class="far fa-edit"></i>
                    <i *ngIf="isInvestigationSectionFrozen" class="fa fa-eye eye"></i>
                  </div>
                </div>
              </div>
              <div class="col-md-4" [hidden]="dynamicLabel['ROOT_CAUSE'].isRemovable == 'Y'">
                <div>
                  <!--  Root Cause -->
                  <label id="root-cause-validation" for="root-cause">
                    {{dynamicLabel['ROOT_CAUSE'].fieldName}}
                  </label> <span class="mandatory-symbol">*</span>
                  <span class="info-icon" *ngIf="dynamicLabel['ROOT_CAUSE'].fieldNotes"
                    [matTooltip]="dynamicLabel['ROOT_CAUSE'].fieldNotes">
                    <img [src]="infoIconSrc" alt="note" width="18" height="18">
                  </span>
                </div>
                <div class="row">
                  <div class="hideToolbar col-sm-11">
                    <st-editor [(ngModel)]="qmsService.activity.rootCause" [config]="config" [spellcheck]="true"
                      (ngModelChange)="onStEditorChange($event, 'root-cause-validation')"
                      [disabled]="isInvestigationSectionFrozen" (paste)="onPaste($event)"></st-editor>
                  </div>
                  <div class="col-sm-1 angular-editor-edit"
                    (keydown.enter)="isInvestigationSectionFrozen ? openEditor('Root Cause', 'eye') : openEditor('Root Cause', 'edit')"
                    (click)="isInvestigationSectionFrozen ? openEditor('Root Cause', 'eye') : openEditor('Root Cause', 'edit')">
                    <i *ngIf="!isInvestigationSectionFrozen" class="far fa-edit"></i>
                    <i *ngIf="isInvestigationSectionFrozen" class="fa fa-eye eye"></i>
                  </div>
                </div>
              </div>
              <div class="col-md-4 field-styles1" [hidden]="dynamicLabel['ROOT_CAUSE_TYPE'].isRemovable == 'Y'">
                <div>
                  <!-- Root Cause Type -->
                  <label id="root-cause-type-validation" for="root-cause-type">
                    {{dynamicLabel['ROOT_CAUSE_TYPE'].fieldName}}
                  </label> <span class="mandatory-symbol">*</span>
                  <span class="info-icon" *ngIf="dynamicLabel['ROOT_CAUSE_TYPE'].fieldNotes"
                    [matTooltip]="dynamicLabel['ROOT_CAUSE_TYPE'].fieldNotes">
                    <img [src]="infoIconSrc" alt="note" width="18" height="18">
                  </span>
                </div>
                <mat-select matInput multiple placeholder="Select" #rootCause
                  [(ngModel)]="qmsService.qiDropDowns.selectedQiRootCauseType" (closed)="rootCauseSearchText=''"
                  (click)="focusSearch('focus-root-cause-search')" [disabled]="isInvestigationSectionFrozen"
                  (keydown.enter)="focusSearch('focus-root-cause-search')">
                  <input type="search" id="focus-rot-cause-search" class="dropdownsearchstyle"
                    [(ngModel)]="rootCauseSearchText" matInput placeholder="search">
                  <div class="select-all">
                    <mat-checkbox [(ngModel)]="isAllRootCause" (change)="toggleAllSelection('rootCause')">Select
                      All</mat-checkbox>
                  </div>
                  <mat-option
                    *ngFor="let item1 of rootCauseTypeDropDown| multiAssessmentSearchPipe :rootCauseSearchText"
                    [value]="item1.valueExp" (onSelectionChange)="onRootCauseTypeSelect($event,item1)">
                    {{ item1.displayExp }}
                  </mat-option>
                </mat-select>
              </div>
              <div class="col-md-4 field-styles1" [hidden]="dynamicLabel['FINAL_IMPACT_ASSESSMENT'].isRemovable == 'Y'">
                <div>
                  <!-- Final Impact Assessment -->
                  <label id="final-impact-validation" for="final-impact">
                    {{dynamicLabel['FINAL_IMPACT_ASSESSMENT'].fieldName}}
                  </label>
                  <span class="info-icon" *ngIf="dynamicLabel['FINAL_IMPACT_ASSESSMENT'].fieldNotes"
                    [matTooltip]="dynamicLabel['FINAL_IMPACT_ASSESSMENT'].fieldNotes">
                    <img [src]="infoIconSrc" alt="note" width="18" height="18">
                  </span>
                </div>
                <div class="row">
                  <div class="hideToolbar col-sm-11">
                    <st-editor [(ngModel)]="qmsService.activity.finalImpactAssessment" [config]="config"
                      [spellcheck]="true" [disabled]="isInvestigationSectionFrozen"
                      (paste)="onPaste($event)"></st-editor>
                  </div>
                  <div class="col-sm-1 angular-editor-edit"
                    (keydown.enter)="isInvestigationSectionFrozen ? openEditor('Final Impact Assessment', 'eye') : openEditor('Final Impact Assessment', 'edit')"
                    (click)="isInvestigationSectionFrozen ? openEditor('Final Impact Assessment', 'eye') : openEditor('Final Impact Assessment', 'edit')">
                    <i *ngIf="!isInvestigationSectionFrozen" class="far fa-edit"></i>
                    <i *ngIf="isInvestigationSectionFrozen" class="fa fa-eye eye"></i>
                  </div>
                </div>
              </div>
              <div class="col-md-4 field-styles1" [hidden]="dynamicLabel['CONCLUSION'].isRemovable == 'Y'">
                <div>
                  <!-- Conclusion -->
                  <label id="conclusion-validation" for="conclusion">
                    {{dynamicLabel['CONCLUSION'].fieldName}}
                  </label> <span class="mandatory-symbol">*</span>
                  <span class="info-icon" *ngIf="dynamicLabel['CONCLUSION'].fieldNotes"
                    [matTooltip]="dynamicLabel['CONCLUSION'].fieldNotes">
                    <img [src]="infoIconSrc" alt="note" width="18" height="18">
                  </span>
                </div>
                <div class="row">
                  <div class="hideToolbar col-sm-11">
                    <st-editor [(ngModel)]="qmsService.activity.conclusion" [config]="config" [spellcheck]="true"
                      [disabled]="isInvestigationSectionFrozen"
                      (ngModelChange)="onStEditorChange($event, 'conclusion-validation')"
                      (paste)="onPaste($event)"></st-editor>
                  </div>
                  <div class="col-sm-1 angular-editor-edit"
                    (keydown.enter)="isInvestigationSectionFrozen ? openEditor('Conclusion', 'eye') : openEditor('Conclusion', 'edit')"
                    (click)="isInvestigationSectionFrozen ? openEditor('Conclusion', 'eye') : openEditor('Conclusion', 'edit')">
                    <i *ngIf="!isInvestigationSectionFrozen" class="far fa-edit"></i>
                    <i *ngIf="isInvestigationSectionFrozen" class="fa fa-eye eye"></i>
                  </div>
                </div>
              </div>
            </div>
          </fieldset>

          <fieldset class="border p-2 fieldsetStyle" *ngIf="this.message.showCompleteQiSection">
            <legend class="float-none w-auto p-2">
              <span class="" style="font-size: 14px;color: #cfcfcf;">Complete&nbsp;{{qmsService.moduleFullName}}</span>
            </legend>
            <div class="row">
              <div class="col-md-3" [hidden]="this.dynamicLabel['RESOLUTION_CATEGORY'].isRemovable == 'Y'">
                <div>
                  <!-- Resolution Category -->
                  <label id="resolution-category-validation" for="resolution-category">
                    {{dynamicLabel['RESOLUTION_CATEGORY'].fieldName}}
                  </label> <span class="mandatory-symbol">*</span>
                  <span class="info-icon" *ngIf="dynamicLabel['RESOLUTION_CATEGORY'].fieldNotes"
                    [matTooltip]="dynamicLabel['RESOLUTION_CATEGORY'].fieldNotes">
                    <img [src]="infoIconSrc" alt="note" width="18" height="18">
                  </span>
                </div>
                <mat-select matInput placeholder="Select"
                  [ngClass]="{'odd-item-mat-select': oddResolution == qmsService.qiDropDowns.selectedQiResolutionCategory}"
                  [(ngModel)]="qmsService.qiDropDowns.selectedQiResolutionCategory" (closed)="resolutionSearchText=''"
                  (click)="focusSearch('focus-resolution-search')" [disabled]="isCompleteSectionFrozen"
                  (keydown.enter)="focusSearch('focus-resolution-search')">
                  <input type="search" id="focus-resolution-search" class="dropdownsearchstyle"
                    [(ngModel)]="resolutionSearchText" matInput placeholder="search">
                  <mat-option [value]="null" class="unselectStyle"
                    (onSelectionChange)="onResolutionCategorySelect($event,null);">Un-select</mat-option>
                  <mat-option *ngFor="let item of resolutionCategoryDropDown | assessmentSearch : resolutionSearchText"
                    (onSelectionChange)="onResolutionCategorySelect($event,item)" [value]="item.valueExp">
                    {{ item.displayExp }}
                  </mat-option>
                </mat-select>
              </div>
              <div class=" col-md-4" [hidden]="dynamicLabel['RESOLUTION_PROVIDED'].isRemovable == 'Y'">
                <div>
                  <!-- Resolution Provided -->
                  <label id="resolution-provided-validation" for="resolution-provided">
                    {{dynamicLabel['RESOLUTION_PROVIDED'].fieldName}}
                  </label> <span class="mandatory-symbol">*</span>
                  <span class="info-icon" *ngIf="dynamicLabel['RESOLUTION_PROVIDED'].fieldNotes"
                    [matTooltip]="dynamicLabel['RESOLUTION_PROVIDED'].fieldNotes">
                    <img [src]="infoIconSrc" alt="note" width="18" height="18">
                  </span>
                </div>
                <textarea type="text" class="input-filed-textarea" style="margin-top: 8px;" rows="4" cols="50"
                  [disabled]="isCompleteSectionFrozen" [(ngModel)]="qmsService.activity.resolutionProvided"
                  (input)="limitCharacters($event, 'RESOLUTION_PROVIDED')"
                  (ngModelChange)="onNgModelChange($event, 'resolution-provided-validation')"></textarea>
              </div>
              <div class="col-md-4" [hidden]="dynamicLabel['CLOSURE_COMMENT'].isRemovable == 'Y'">
                <div>
                  <!-- Closure Comment -->
                  <label id="closure-comments-validation" for="closure-comments">
                    {{dynamicLabel['CLOSURE_COMMENT'].fieldName}}
                  </label> <span class="mandatory-symbol">*</span>
                  <span class="info-icon" *ngIf="dynamicLabel['CLOSURE_COMMENT'].fieldNotes"
                    [matTooltip]="dynamicLabel['CLOSURE_COMMENT'].fieldNotes">
                    <img [src]="infoIconSrc" alt="note" width="18" height="18">
                  </span>
                </div>
                <textarea type="text" class="input-filed-textarea" style="margin-top: 8px;" rows="4" cols="50"
                  [disabled]="isCompleteSectionFrozen" (input)="limitCharacters($event, 'CLOSURE_COMMENT')"
                  [(ngModel)]="qmsService.activity.closureComment"
                  (ngModelChange)="onNgModelChange($event, 'closure-comments-validation')"></textarea>
              </div>
            </div>
          </fieldset>
        </div>
        <fieldset class="border p-2 crFieldsetStyle">
          <legend class="float-none w-auto p-2">
            <span class="" style="font-size: 14px;color: #cfcfcf;">More Info</span>
          </legend>
          <div class="row field-styles1" style="margin-top: -1%;">
            <div class="col-md-2" *ngIf="qmsService.activity.lastActionOn">
              <div>
                <label for="email">
                  {{dynamicLabel['LAST_ACTION_ON']?.fieldName}}
                </label>
              </div>
              <input type="text" class="form-control data-picker-continer" bsDatepicker [bsConfig]="dateTimeConfig"
                [dateCustomClasses]="dateCustomClasses" [(ngModel)]="qmsService.activity.lastActionOn"
                [disabled]="true">
            </div>
            <div class="col-md-2" *ngIf="qmsService.activity.lastActionByUser">
              <div>
                <label for="email">
                  {{dynamicLabel['LAST_ACTION_BY_USER']?.fieldName}}
                </label>
              </div>
              <input type="text" class="input-filed-continers" [(ngModel)]="qmsService.activity.lastActionByUser"
                [disabled]="true">
            </div>
            <div class="col-md-2" *ngIf="qmsService.activity.lastActionComments">
              <div>
                <label for="email">
                  {{dynamicLabel['LAST_ACTION_COMMENTS']?.fieldName}}
                </label>
              </div>
              <input type="text" class="input-filed-continers" [(ngModel)]="qmsService.activity.lastActionComments"
                [disabled]="true">
            </div>
          </div>
        </fieldset>
        <div class="form-template ActivityPage" id="Additionaldetail" style="margin-top:1%;">
          <app-flexible-fields #flexible [from]="'Details'"></app-flexible-fields>
        </div>
      </mat-tab>
      <div *ngFor="let tabPage of message.tabPagesOrderlist; let idx = index;">
        <mat-tab label="Documents" *ngIf="message.showDocumentSection  && tabPage=='Files'">
          <ng-template mat-tab-label>
            <span>
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M11.2501 1.80005V4.50005C11.2501 4.99711 11.6531 5.40005 12.1501 5.40005H14.8501M6.30014 5.40005H8.10014M6.30014 8.10005H11.7001M6.30014 10.8H11.7001M13.5001 3.15005C13.0996 2.79165 12.6839 2.36658 12.4215 2.09051C12.2469 1.9068 12.0057 1.80005 11.7522 1.80005H4.94993C3.95582 1.80005 3.14993 2.60593 3.14993 3.60004L3.14986 14.4C3.14985 15.3941 3.95573 16.2 4.94985 16.2L13.0499 16.2C14.044 16.2 14.8499 15.3942 14.8499 14.4001L14.8501 4.85842C14.8501 4.62829 14.7623 4.40708 14.6026 4.2414C14.3073 3.93503 13.8141 3.43094 13.5001 3.15005Z"
                  stroke="#005C8A" [ngStyle]="{strokeWidth: selectedTab == 'Documents' ? '2' : ''}"
                  stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </span>&nbsp;
            <span>Files</span>
          </ng-template>
          <div class="form-template ActivityPage" id="Documents" style="margin-top:1%;">
            <app-task-documents (valueChange)="on_documents_emit($event)" *ngIf="selectedTab === 'Documents'"
              [activity]="this.objForDocuments"></app-task-documents>
          </div>
        </mat-tab>

        <mat-tab label="Risk Assessment" *ngIf="message.showRiskTab && tabPage=='Risk Assessment'">
          <ng-template mat-tab-label>
            <span>
              <img src="../../assets/img/warning (1).png" alt="tasks" width="20" height="20" class="ng-star-inserted">
            </span>&nbsp;
            <span>Risk Assessment</span>
          </ng-template>
          <div class="form-template ActivityPage" id="Risk Assesment" style="margin-top:1%;">
            <app-risk [pagename]="'activity'" *ngIf="selectedTab === 'Risk Assessment'"
              [isRiskFieldsActivited]="true"></app-risk>
          </div>
        </mat-tab>

        <mat-tab label="Preliminary Actions" *ngIf="message.showPreActionsTab && tabPage=='Preliminary Actions'">
          <ng-template mat-tab-label>
            <span>
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="1.8" cy="10" r="1.5" stroke="#0F3659"
                  [ngStyle]="{strokeWidth: selectedTab == 'Preliminary Actions' ? '2' : '1.2'}" />
                <path d="M4.2 9H6.6L8.3 4.5L10.8 13.5L12 9H15.5" stroke="#0F3659" stroke-linecap="round"
                  stroke-linejoin="round" [ngStyle]="{strokeWidth: selectedTab == 'Preliminary Actions' ? '2' : ''}" />
              </svg> &nbsp;
              <span>Preliminary Actions</span>
            </span>
          </ng-template>
          <div class="form-template ActivityPage" id="Actions" style="margin-top:1%;">
            <app-pre-actions *ngIf="selectedTab === 'Preliminary Actions'" [activityData]=" true"></app-pre-actions>
          </div>
        </mat-tab>

        <mat-tab label="Actions" *ngIf="message.showActionSection && tabPage=='Actions'">
          <ng-template mat-tab-label>
            <span>
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2 8.99947H5.6L7.4364 3L11.3944 15.6L12.7913 8.99947H16.4" stroke="#0F3659"
                  stroke-linecap="round" stroke-linejoin="round"
                  [ngStyle]="{strokeWidth: selectedTab == 'Actions' ? '2' : ''}" />
              </svg>
            </span>&nbsp;
            <span>Actions</span>
          </ng-template>
          <div class="form-template ActivityPage" style="margin-top:1%;">
            <app-actions *ngIf="selectedTab === 'Actions'" (valueChange)="on_action_emit($event)"
              [activityData]="true"></app-actions>
          </div>
        </mat-tab>
        <mat-tab label="Workflow" *ngIf="parallelWorkflowList.length>0 && tabPage=='Parallel Workflow'">
          <ng-template mat-tab-label>
            <span>
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M11.3272 2.32701L11.6808 1.97346V1.97346L11.3272 2.32701ZM13.8728 4.8726L13.5192 5.22615L13.8728 4.8726ZM7.44645 12.3534C7.64172 12.5486 7.9583 12.5486 8.15356 12.3534C8.34882 12.1581 8.34882 11.8415 8.15356 11.6462L7.44645 12.3534ZM6.30001 10.4998L5.94645 10.1462C5.85268 10.24 5.80001 10.3672 5.80001 10.4998C5.80001 10.6324 5.85268 10.7596 5.94645 10.8534L6.30001 10.4998ZM8.15356 9.35336C8.34882 9.15809 8.34882 8.84151 8.15356 8.64625C7.9583 8.45099 7.64172 8.45099 7.44645 8.64625L8.15356 9.35336ZM10.5536 8.64625C10.3583 8.45099 10.0417 8.45099 9.84645 8.64625C9.65119 8.84151 9.65119 9.15809 9.84645 9.35336L10.5536 8.64625ZM11.7 10.4998L12.0536 10.8534C12.2488 10.6581 12.2488 10.3415 12.0536 10.1462L11.7 10.4998ZM9.84645 11.6463C9.65119 11.8415 9.65119 12.1581 9.84645 12.3534C10.0417 12.5486 10.3583 12.5486 10.5536 12.3534L9.84645 11.6463ZM12.6 15.6998H5.40001V16.6998H12.6V15.6998ZM4.10001 14.3998V3.5998H3.10001V14.3998H4.10001ZM5.40001 2.2998H10.0544V1.2998H5.40001V2.2998ZM13.9 6.14539V14.3998H14.9V6.14539H13.9ZM10.0544 2.2998C10.3992 2.2998 10.7299 2.43677 10.9737 2.68057L11.6808 1.97346C11.2494 1.54213 10.6644 1.2998 10.0544 1.2998V2.2998ZM5.40001 15.6998C4.68204 15.6998 4.10001 15.1178 4.10001 14.3998H3.10001C3.10001 15.6701 4.12975 16.6998 5.40001 16.6998V15.6998ZM12.6 16.6998C13.8703 16.6998 14.9 15.6701 14.9 14.3998H13.9C13.9 15.1178 13.318 15.6998 12.6 15.6998V16.6998ZM13.5192 5.22615C13.763 5.46995 13.9 5.80061 13.9 6.14539H14.9C14.9 5.53539 14.6577 4.95038 14.2264 4.51904L13.5192 5.22615ZM4.10001 3.5998C4.10001 2.88183 4.68204 2.2998 5.40001 2.2998V1.2998C4.12975 1.2998 3.10001 2.32955 3.10001 3.5998H4.10001ZM9.40001 1.7998V5.3998H10.4V1.7998H9.40001ZM10.8 6.7998H14.4V5.7998H10.8V6.7998ZM9.40001 5.3998C9.40001 6.173 10.0268 6.7998 10.8 6.7998V5.7998C10.5791 5.7998 10.4 5.62072 10.4 5.3998H9.40001ZM10.9737 2.68057L13.5192 5.22615L14.2264 4.51904L11.6808 1.97346L10.9737 2.68057ZM8.15356 11.6462L6.65356 10.1462L5.94645 10.8534L7.44645 12.3534L8.15356 11.6462ZM6.65356 10.8534L8.15356 9.35336L7.44645 8.64625L5.94645 10.1462L6.65356 10.8534ZM9.84645 9.35336L11.3465 10.8534L12.0536 10.1462L10.5536 8.64625L9.84645 9.35336ZM11.3465 10.1462L9.84645 11.6463L10.5536 12.3534L12.0536 10.8534L11.3465 10.1462Z"
                  fill="#0F3659" stroke="#0F3659"
                  [ngStyle]="{strokeWidth: selectedTab == 'Extension' ? '0.65' : '0.25'}" />
              </svg> </span>&nbsp;
            <span>Parallel Workflow</span>
          </ng-template>
          <div class="form-template ActivityPage" id="Workflow" style="margin-top:1%;">
            <app-parallel-workflow *ngIf="selectedTab === 'Workflow'" [showGrid]="true"></app-parallel-workflow>
          </div>
        </mat-tab>
        <mat-tab label="Extension" *ngIf="message.showExtensionSection && tabPage=='Extension'">
          <ng-template mat-tab-label>
            <span>
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M11.3272 2.32701L11.6808 1.97346V1.97346L11.3272 2.32701ZM13.8728 4.8726L13.5192 5.22615L13.8728 4.8726ZM7.44645 12.3534C7.64172 12.5486 7.9583 12.5486 8.15356 12.3534C8.34882 12.1581 8.34882 11.8415 8.15356 11.6462L7.44645 12.3534ZM6.30001 10.4998L5.94645 10.1462C5.85268 10.24 5.80001 10.3672 5.80001 10.4998C5.80001 10.6324 5.85268 10.7596 5.94645 10.8534L6.30001 10.4998ZM8.15356 9.35336C8.34882 9.15809 8.34882 8.84151 8.15356 8.64625C7.9583 8.45099 7.64172 8.45099 7.44645 8.64625L8.15356 9.35336ZM10.5536 8.64625C10.3583 8.45099 10.0417 8.45099 9.84645 8.64625C9.65119 8.84151 9.65119 9.15809 9.84645 9.35336L10.5536 8.64625ZM11.7 10.4998L12.0536 10.8534C12.2488 10.6581 12.2488 10.3415 12.0536 10.1462L11.7 10.4998ZM9.84645 11.6463C9.65119 11.8415 9.65119 12.1581 9.84645 12.3534C10.0417 12.5486 10.3583 12.5486 10.5536 12.3534L9.84645 11.6463ZM12.6 15.6998H5.40001V16.6998H12.6V15.6998ZM4.10001 14.3998V3.5998H3.10001V14.3998H4.10001ZM5.40001 2.2998H10.0544V1.2998H5.40001V2.2998ZM13.9 6.14539V14.3998H14.9V6.14539H13.9ZM10.0544 2.2998C10.3992 2.2998 10.7299 2.43677 10.9737 2.68057L11.6808 1.97346C11.2494 1.54213 10.6644 1.2998 10.0544 1.2998V2.2998ZM5.40001 15.6998C4.68204 15.6998 4.10001 15.1178 4.10001 14.3998H3.10001C3.10001 15.6701 4.12975 16.6998 5.40001 16.6998V15.6998ZM12.6 16.6998C13.8703 16.6998 14.9 15.6701 14.9 14.3998H13.9C13.9 15.1178 13.318 15.6998 12.6 15.6998V16.6998ZM13.5192 5.22615C13.763 5.46995 13.9 5.80061 13.9 6.14539H14.9C14.9 5.53539 14.6577 4.95038 14.2264 4.51904L13.5192 5.22615ZM4.10001 3.5998C4.10001 2.88183 4.68204 2.2998 5.40001 2.2998V1.2998C4.12975 1.2998 3.10001 2.32955 3.10001 3.5998H4.10001ZM9.40001 1.7998V5.3998H10.4V1.7998H9.40001ZM10.8 6.7998H14.4V5.7998H10.8V6.7998ZM9.40001 5.3998C9.40001 6.173 10.0268 6.7998 10.8 6.7998V5.7998C10.5791 5.7998 10.4 5.62072 10.4 5.3998H9.40001ZM10.9737 2.68057L13.5192 5.22615L14.2264 4.51904L11.6808 1.97346L10.9737 2.68057ZM8.15356 11.6462L6.65356 10.1462L5.94645 10.8534L7.44645 12.3534L8.15356 11.6462ZM6.65356 10.8534L8.15356 9.35336L7.44645 8.64625L5.94645 10.1462L6.65356 10.8534ZM9.84645 9.35336L11.3465 10.8534L12.0536 10.1462L10.5536 8.64625L9.84645 9.35336ZM11.3465 10.1462L9.84645 11.6463L10.5536 12.3534L12.0536 10.8534L11.3465 10.1462Z"
                  fill="#0F3659" stroke="#0F3659"
                  [ngStyle]="{strokeWidth: selectedTab == 'Extension' ? '0.65' : '0.25'}" />
              </svg>
            </span>&nbsp;
            <span>Extension</span>
          </ng-template>
          <div class="form-template ActivityPage" id="Extendsion" style="margin-top:1%;">
            <app-task-extensions [activityData]="true" (extension)="on_extension_emit($event)"
              *ngIf="selectedTab === 'Extension'"></app-task-extensions>
          </div>
        </mat-tab>
        <mat-tab label="Reviewer/Approver"
          *ngIf="message.showReviewApproveSection && !isStageUsersSkipped  && tabPage=='Reviewer/Approver'">
          <ng-template mat-tab-label>
            <span>
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M7.72486 16.2H4.12485C3.13074 16.2 2.32485 15.3941 2.32486 14.4L2.32493 3.60004C2.32494 2.60593 3.13082 1.80005 4.12493 1.80005H12.2251C13.2192 1.80005 14.0251 2.60594 14.0251 3.60005V8.55005M10.4251 13.65L12.0751 15.3L15.6751 11.6999M5.47514 5.40005H10.8751M5.47514 8.10005H10.8751M5.47514 10.8H8.17514"
                  stroke="#0F3659" stroke-linecap="round" stroke-linejoin="round"
                  [ngStyle]="{strokeWidth: selectedTab == 'Reviewer/Approver' ? '2' : ''}" />
              </svg>
            </span>&nbsp;
            <span>Reviewer/Approver</span>
          </ng-template>
          <div class="form-template ActivityPage" id="Reviewers/Approvers" style="margin-top:1%;">
            <app-stageusers *ngIf="selectedTab === 'Reviewer/Approver'" (valueChange)="on_stageUser_emit($event)"
              [activityData]="this.qmsService.activity"></app-stageusers>
          </div>
        </mat-tab>

        <mat-tab label="Dependency" *ngIf="message.showDependancySection && tabPage=='Dependency'">
          <ng-template mat-tab-label>
            <span>
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M13.05 7.36653L16.2 8.98115L8.99999 12.6717L1.79999 8.98115L5.00756 7.33702M13.05 10.8946L16.2 12.5092L8.99999 16.1998L1.79999 12.5092L5.00756 10.8651M8.99999 1.7998L16.2 5.49036L8.99999 9.18092L1.79999 5.49036L8.99999 1.7998Z"
                  stroke="#0F3659" [ngStyle]="{strokeWidth: selectedTab == 'Dependancy' ? '2' : ''}"
                  stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </span>&nbsp;
            <span>Dependency</span>
          </ng-template>
          <div class="form-template ActivityPage" id="Dependency" style="margin-top:1%;">
            <app-quality-dependencies *ngIf="selectedTab === 'Dependency'"></app-quality-dependencies>
          </div>
        </mat-tab>

        <mat-tab label="Effectiveness Check" *ngIf="message.showEffectiveSection  && tabPage=='Effectiveness Check'">
          <ng-template mat-tab-label>
            <span>
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M11.7 7.19981L7.67277 10.7998L6.3 9.57266M16.2 4.4998L16.2 13.4999C16.2 14.9911 14.9912 16.1999 13.5 16.1999H4.5C3.00883 16.1999 1.8 14.9911 1.8 13.4999V4.4998C1.8 3.00864 3.00883 1.7998 4.5 1.7998H13.5C14.9912 1.7998 16.2 3.00864 16.2 4.4998Z"
                  stroke="#0F3659" stroke-linecap="round" stroke-linejoin="round"
                  [ngStyle]="{strokeWidth: selectedTab == 'Effectiveness Check' ? '2' : ''}" />
              </svg>
            </span>&nbsp;
            <span>Effectiveness Check</span>
          </ng-template>
          <div class="form-template ActivityPage" *ngIf="message.showEffectiveSection" id="Effectiveness Check"
            style="margin-top:1%;">
            <app-tasks-ec (valueChange)="on_effectiveness_emit($event)" *ngIf="selectedTab === 'Effectiveness Check'"
              [activityData]="true"></app-tasks-ec>
          </div>
        </mat-tab>

        <mat-tab label="Notifications" *ngIf="tabPage=='Notifications'&& isAdditionalTabUser">
          <ng-template mat-tab-label>
            <span><i class="fa-solid fa-bell" style="font-size: 17px;"></i></span>&nbsp;
            <span>Notifications</span>
          </ng-template>
          <div class="form-template ActivityPage" style="margin-top:1%;">
            <app-activity-notifications *ngIf="selectedTab === 'Notifications'"></app-activity-notifications>
          </div>
        </mat-tab>
        <mat-tab label="History" *ngIf="tabPage=='History'&& isAdditionalTabUser">
          <ng-template mat-tab-label>
            <span>
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M10.8875 10.7998L8.18755 9.8998V6.1365M15.3875 8.9998C15.3875 5.02335 12.164 1.7998 8.18755 1.7998C4.2111 1.7998 0.987549 5.02335 0.987549 8.9998C0.987549 12.9763 4.2111 16.1998 8.18755 16.1998C10.8526 16.1998 13.1794 14.7519 14.4243 12.5998M13.4124 8.20968L15.2124 10.0097L17.0124 8.20968"
                  stroke="#0F3659" stroke-linecap="round" stroke-linejoin="round"
                  [ngStyle]="{strokeWidth: selectedTab == 'History' ? '2' : ''}" />
              </svg>
            </span>&nbsp;
            <span>History</span>
          </ng-template>
          <div class="form-template ActivityPage" style="margin-top:1%;">
            <app-task-history *ngIf="selectedTab === 'History'"></app-task-history>
          </div>
        </mat-tab>
      </div>
    </mat-tab-group>
  </div>

  <ng-template #editor>
    <div class="page-loading-shade" *ngIf="isProcessing">
      <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelEditor()" mat-button><i
        class="fa popupClose">&#xf00d;</i></button>
    <div mat-dialog-title>
      <label for="title" class="popupTitle"> {{this.editorTitle}}</label>
      <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <br>
    <div class="row">
      <div class="col-md-12 st-editor">
        <st-editor [(ngModel)]="editorValue" [config]=" allowEditing ? config1 : config" [spellcheck]="true"
          (paste)="onPaste($event)"></st-editor>
      </div>
    </div>
    <div class="button-continer btn-align" mat-dialog-actions>
      <button mat-stroked-button *ngIf="allowEditing" class="addButton" (click)="saveEditor(editorValue)">
        <i class="fas fa-check"></i> Save
      </button>
      <button mat-stroked-button class="cancelButton" (click)="cancelEditor()">
        <i class="fa fa-close"></i> Cancel
      </button>
    </div>
  </ng-template>

  <ng-template #topicPopup>
    <div class="page-loading-shade" *ngIf="isProcessing">
      <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" mat-button (click)="canceltopicPopup()">
      <i class="fa popupClose">&#xf00d;</i>
    </button>
    <div mat-dialog-title>
      <label for="title" class="popupTitle"> {{qmsService.moduleFullName}}&nbsp;Topics </label>
      <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <app-oneqms-topics [topicData]=""></app-oneqms-topics>
  </ng-template>

  <ng-template #mandatoryPopup>
    <div class="page-loading-shade" *ngIf="isProcessing">
      <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>

    <button class="close close-button" (click)="closeMandatoryPopup()" mat-button>
      <i class="fa popupClose">&#xf00d;</i>
    </button>

    <div mat-dialog-title>
      <label for="title" class="popupTitle"> Mandatory Alert </label>
    </div>

    <div style="margin: 15px 15px;">
      <div style="display: flex; justify-content: center; align-items: center;">
        <span style="font-weight: 500; font-size: larger;"> Please enter all Mandatory Fields
          <span style="color: red; font-size: x-large;"><i class="fa-solid fa-exclamation"></i></span>
        </span>
      </div>
      <div class="button-continer btn-align" mat-dialog-actions>
        <button mat-stroked-button class="cancelButton" (click)="closeMandatoryPopup()">
          Ok
        </button>
      </div>
    </div>
  </ng-template>

  <!-- PDF Report Popup-->
  <ng-template #openExportReportPopup>
    <div class="page-loading-shade" *ngIf="isProcessing">
      <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" mat-button (click)="cancelExportPopup()"><i
        class="fa popupClose">&#xf00d;</i></button>
    <div mat-dialog-title>
      <label for="title" class="popupTitle"> Choose Report Template </label>
      <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div class="form-continer1">
      <div class="row justify-content-md-center">
        <div class="col-sm-4">
          <label id="reportTemplate-validation" for="email">Report Template</label><span
            class="mandatory-symbol">*</span>
        </div>
        <div class="col-sm-8">
          <mat-select matInput placeholder="Select" [(ngModel)]="selectedReportTemplateValue"
            (closed)="pdfDetailSearchText=''" (click)="focusSearch('focus-group-search')"
            (keydown.enter)="focusSearch('focus-group-search')">
            <input type="search" id="focus-group-search" class="dropdownsearchstyle" [(ngModel)]="pdfDetailSearchText"
              matInput placeholder="search">
            <mat-option [value]="null" class="unselectStyle"
              (onSelectionChange)="onPdfDetailValueSelect($event,null);">Un-select</mat-option>
            <mat-option *ngFor="let item of reportTemplateDropdown | assessmentSearch : pdfDetailSearchText"
              (onSelectionChange)="onPdfDetailValueSelect($event,item)" [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>
      </div>
      <div class="row justify-content-md-center">
        <div class="col-sm-4">
          <label for="email">Report Logo</label>
        </div>
        <div class="col-sm-8">
          <mat-select matInput placeholder="Select" [(ngModel)]="selectedReportLogoValue"
            (closed)="pdfDetailSearchText=''" (click)="focusSearch('focus-group-search')"
            (keydown.enter)="focusSearch('focus-group-search')">
            <input type="search" id="focus-Logo-search" class="dropdownsearchstyle" [(ngModel)]="pdfDetailSearchText"
              matInput placeholder="search">
            <mat-option [value]="null" class="unselectStyle"
              (onSelectionChange)="onReportLogoValueSelect($event,null);">Un-select</mat-option>
            <mat-option *ngFor="let item of reportLogoDropdown | assessmentSearch : pdfDetailSearchText"
              (onSelectionChange)="onReportLogoValueSelect($event,item)" [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>
      </div>
      <div class="row justify-content-md-center">
        <div class="col-sm-4">
          <label for="email">Select Footer</label><span class="mandatory-symbol">*</span>
        </div>
        <div class="col-sm-8">
          <mat-select matInput placeholder="Select" [(ngModel)]="selectedReportFooter" (closed)="pdfDetailSearchText=''"
            (click)="focusSearch('focus-Logo-search')" (keydown.enter)="focusSearch('focus-Logo-search')">
            <input type="search" id="focus-footer-search" class="dropdownsearchstyle" [(ngModel)]="pdfDetailSearchText"
              matInput placeholder="search">

            <mat-option *ngFor="let item of reportFooterDropdown | assessmentSearch : pdfDetailSearchText"
              (onSelectionChange)="onReportFooterSelect($event,item)" [value]="item.displayExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>
      </div>
      <div class="row justify-content-md-center">
        <div class="col-sm-4">
          <label for="email">Is Save Report?</label>
        </div>
        <div class="col-sm-8">
          <mat-slide-toggle color="primary" name="reportEnabled" [(ngModel)]="isSaveReport">
            <ng-container *ngIf="isSaveReport; else noisSaveReport">
              <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
            </ng-container>
            <ng-template #noisSaveReport>
              <span style="color: red;">No</span>
            </ng-template>
          </mat-slide-toggle>
        </div>
      </div>
      <div class="row justify-content-md-center" *ngIf="isSaveReport">
        <div class="col-sm-4">
          <label for="email">Report Name</label><span class="mandatory-symbol">*</span>
        </div>
        <div class="col-sm-8">
          <input type="text" class="input-filed-continers" [(ngModel)]="reportName">
        </div>
      </div>
      <div class="row justify-content-md-center">
        <div class="col-sm-4">
          <label for="email">Attach all documents?</label>
        </div>
        <div class="col-sm-8">
          <mat-slide-toggle color="primary" name="reportEnabled" [(ngModel)]="attachAllDocuments">
            <ng-container *ngIf="attachAllDocuments; else noattachAllDocuments">
              <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
            </ng-container>
            <ng-template #noattachAllDocuments>
              <span style="color: red;">No</span>
            </ng-template>
          </mat-slide-toggle>
        </div>
      </div>
      <div class="row justify-content-md-center" *ngIf="attachAllDocuments">

        <label for="email">Attachments to the report are limited to PDF, DOC, or DOCX formats.</label>
      </div>
    </div>
    <div class="button-continer btn-align" mat-dialog-actions>
      <button mat-stroked-button class="addButton" (click)="exportReportGenerateFuntion()">
        <i class="fas fa-check"></i> Generate
      </button>
      <button mat-stroked-button class="cancelButton" (click)="exportReportCancelPopupFuntion()">
        <i class="fa fa-close"></i> Cancel
      </button>
    </div>
  </ng-template>

  <app-switchuser #switchUserPopup1 (valueEmitter)="onChildValueEmitted()"></app-switchuser>
  <app-top-navigation [hidden]="true"></app-top-navigation>
  <app-add-parallel-workflows (valueEmitter)="onworkflowChildValueEmitted()"
    *ngIf="addworkflow"></app-add-parallel-workflows>

  <app-homepagetag #tagRecordPopup (valueEmitter)="onTagChildValueEmitted()"></app-homepagetag>
  <app-moduletype (valueEmitter)="onModuleTypeEmitted($event)" [parentData]="moduleTypeData"></app-moduletype>
  <app-quality-dependents></app-quality-dependents>
